import { render, staticRenderFns } from "./CustomCarrierCostsOverview.vue?vue&type=template&id=75b3a1b6&scoped=true&"
import script from "./CustomCarrierCostsOverview.vue?vue&type=script&lang=js&"
export * from "./CustomCarrierCostsOverview.vue?vue&type=script&lang=js&"
import style0 from "./CustomCarrierCostsOverview.vue?vue&type=style&index=0&id=75b3a1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b3a1b6",
  null
  
)

export default component.exports